// extracted by mini-css-extract-plugin
module.exports = {"center":"ModalHub_center__27JYm","backdrop":"ModalHub_backdrop__1HXh9"};